module.exports = __webpack_public_path__ + "media/dashboard/assets/images/getting-started/getting-started-welcome-new-c9c72e48925df68e3413b8c49b5b4e5c.svg";